import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class AdvertisementService extends ApiFactory {
  constructor() {
    super('Advertisement');
  }

  /**
   * 取得 是否顯示咖啡券蓋板狀態
   *
   * @remarks 後端處理顯示條件：
   * - 是否已申請過
   * - 是否為七天內新註冊的會員
   */
  getCoffeeStatus(): Promise<ApiDataResponse<boolean>> {
    return super.get(`GetCoffeeStatus`, null, {
      headers: {
        'Content-Type': 'application/json',
        disableGlobalLoading: true
      }
    });
  }

  /**
   * 領取咖啡券與申請試聽 (寄送 Email 至顧問指定信箱)
   */
  createApplyCoffee(): Promise<ApiDataResponse<boolean>> {
    return super.post(`ApplyCoffee`, null);
  }
}
